import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        width: '300px'
    },
    title: {
        display: 'flex', 
        justifyContent: 'center', 
        marginBottom: 12
    },
    wrapBtn: {
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 8
    },
    ok: {
        background: 'gold', 
        width: '50%', 
        display: 'flex', 
        justifyContent: 'center',
        borderRadius: 4, 
        padding: '10px 0'
    },
    cancel: {
        background: '#fff', 
        border: '1px solid #333', 
        width: '50%', 
        display: 'flex', 
        justifyContent: 'center', 
        borderRadius: 4, 
        padding: '10px 0'
    }
}))

export {
    useStyles
}